import {Alert, Box, Button, Card, CardContent, CircularProgress, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";

export default function TabTopProducts({title, status, error, reload, data, children}) {
    const {t} = useTranslation();
    return <Card component="section" aria-label={title} sx={{minWidth: 0}}><CardContent>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>{t("AnalyticsRankingScope")}</Typography>
        <Typography variant="caption" display="block" sx={{mb: 2}}>{t("DistributorSalesFormula")}</Typography>
        {status === "loading" ? <Box py={5} textAlign="center"><CircularProgress aria-label={t("Loading")}/></Box>
            : error ? <Alert severity="error" action={<Button onClick={reload}>{t("Retry")}</Button>}>{t(error)}</Alert>
            : data?.length === 0 ? <Typography role="status">{t("DistributorAnalyticsEmpty")}</Typography>
            : data && children}
    </CardContent></Card>;
}
